const MATHJAX_VERSION = "2.7.5";
const CONFIG = "TeX-AMS_SVG";

// from https://cdnjs.com/libraries/mathjax
const MATHJAX_URL = `https://cdnjs.cloudflare.com/ajax/libs/mathjax/${MATHJAX_VERSION}/MathJax.js?config=${CONFIG}`;

const DEV = process.env.NODE_ENV !== "production";

const SKIP_PARAM = /\bmathjax=0\b/; // url?mathjax=0 to skip mathjax typeset

let isLoading = false;

declare global {
  interface Window {
    MathJax: any;
  }
}

function loadMathJax() {
  return new Promise<void>((resolve) => {
    const script = document.createElement("script");
    script.src = MATHJAX_URL;
    script.async = true;
    script.onload = () => {
      const MathJax = window.MathJax;
      console.log(`loaded MathJax/${MathJax.version} (${CONFIG})`);

      // http://docs.mathjax.org/en/v2.5-latest/options/hub.html
      MathJax.Hub.Config({
        messageStyle: DEV ? "normal" : "none",
        skipStartupTypeset: true,
        tex2jax: {
          inlineMath: [["$$", "$$"]],
          displayMath: [],
          processEscapes: true,
        },
        extensions: ["jsMath2jax.js"],
      });
      MathJax.Hub.Register.MessageHook("Math Processing Error", (message) => {
        console.error(message);
      });
      MathJax.Hub.Register.StartupHook("End", () => {
        resolve();
      });
    };
    document.head!.appendChild(script);
  });
}

type TargetsType = globalThis.NodeListOf<HTMLElement> | ReadonlyArray<HTMLElement>;

function triggerTypeset(targets: TargetsType) {
  return new Promise<void>((resolve) => {
    if (SKIP_PARAM.test(window.location.href)) {
      return;
    }

    const MathJax = window.MathJax;
    console.assert(MathJax && MathJax.isReady);

    MathJax.Callback.Queue(() => {
      const elements = Array.from(targets);
      MathJax.Hub.Typeset(elements, () => {
        console.log(`typeset is done for ${elements.length} elements.`);
        resolve();
      });
    });
  });
}

export async function requestTypeset(targets: TargetsType = document.querySelectorAll(".markdown-body")) {
  if (targets.length === 0) {
    return;
  }

  const MathJax = window.MathJax;
  if (MathJax && MathJax.isReady) {
    await triggerTypeset(targets);
  } else {
    if (isLoading) {
      return;
    }
    isLoading = true;

    await loadMathJax();
    await triggerTypeset(targets);
  }
}
